import Reflux from "reflux";

import Chip from "@javascript/reactComponents/lds/chips/Chip"
import FacetSearchStore from "@javascript/stores/facetSearchStore";
import { removeSearchCriteriaFilter } from "@javascript/helpers/searchFilterUtilities";

const FacetSearchCriteriaEntities = createReactClass({
  mixins: [
    Reflux.connectFilter(FacetSearchStore, function (data) {
      return {
        filterCriteria: data.filterCriteria,
        facets: data.facets,
      };
    }),
  ],
  getInitialState() {
    return {
      filterCriteria: FacetSearchStore.data.filterCriteria,
      facets: FacetSearchStore.data.facets,
    };
  },

  render() {
    const { filterCriteria, facets } = this.state;

    if (!filterCriteria || Object.keys(filterCriteria).length === 0) return null;

    const originalFacets = Zymewire.original_feed_query?.facets || {};
    const typeToIcon = {
      conditions: "entity",
      organizations: "company",
      therapies: "entity",
    };

    const criterias = Object.entries(filterCriteria).map(([type, terms]) => ({
      type,
      terms: terms.map((term) => {
        // First check if facets[type] exists and has terms
        const facetTerms = facets[type]?.terms || [];
        const facet = facetTerms.find(f => f.term === term) || { term, name: term, count: 0 };

        // Check for locked status
        if (originalFacets[type]?.includes(facet.term)) {
          facet.locked = true;
        }
        return facet;
      })
    }));

    const components = criterias.flatMap((criteria) =>
      criteria.terms.map((term) => (
        <EntityCriteriaEntry
          criteriaDetails={term}
          criteriaType={criteria.type}
          icon={typeToIcon[criteria.type]}
          key={`${criteria.type}_${term.name}`}
          locked={term.locked}
        />
      ))
    );

    return <>{components}</>;

  }
});

const EntityCriteriaEntry = ({
  criteriaDetails,
  criteriaType,
  icon,
  locked,
}) => {

  const criteriaName = criteriaDetails.name;

  const entityNameMap = {
    medical_technologies: "Medical Technologies",
    pharma_ingredients: "Pharma Ingredients",
    trials: "Trials",
    conditions: "Conditions"
  };

  const getEntityDisplayName = () => {
    return Zymewire.facet_search_filters[criteriaType] || entityNameMap[criteriaType]
  }

  const removeCriteria = () => {
    if(locked) return false;
    removeSearchCriteriaFilter(criteriaType, criteriaName);
  };

  return (
    <Chip
      className="search_filter_applied_chip"
      label={`${getEntityDisplayName()}: ${criteriaName}`}
      leadingIcon={icon}
      size="small"
      {...!locked && {
        trailingIcon: "cancel",
        trailingIconClassName: "search_filter_applied_trailing_icon",
        trailingIconOnClick: removeCriteria,
      }}
      title={`You are filtering your search by '${criteriaName}'. Click to remove this filter.`}
      variant="secondary"
    />
  );
};

window.FacetSearchCriteriaEntities = FacetSearchCriteriaEntities;
export default FacetSearchCriteriaEntities;
